import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useChapterAdd({ axiosConfigs = {} } = {}) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addChapter({ classID, courseID, ...data }) {
    return privateFetch
      .post(`/v1/admin/class/${classID}/course/${courseID}/chapter`, data, axiosConfigs)
      .then((res) => res.data);
  }

  async function updateChapter({ classID, courseID, chapterID, ...data }) {
    return privateFetch.put(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}`,
      data,
      axiosConfigs
    );
  }

  async function deleteChapter({ classID, courseID, chapterID }) {
    return privateFetch.delete(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}`,
      axiosConfigs
    );
  }

  function manageChapter(data = {}) {
    if (data?.type === 'DELETE') {
      return deleteChapter(data);
    }

    if (data?.type === 'UPDATE') {
      return updateChapter(data);
    }

    return addChapter(data);
  }

  return useMutation(manageChapter, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useChapterAdd;
